import Vue from 'vue';
import { store } from '../store/store';

export default {

  insertGoogleAnalyticsSnippet() {
    if (Vue.googleAnalyticsInserted) {
      console.warn('Google Analytics snippet was already inserted');
      return;
    }

    let head = document.getElementsByTagName('head')[0];

    let script = document.createElement('script');
    script.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${Vue.googleAnalyticsId}`);
    script.setAttribute('async', '');
    head.appendChild(script);

    let initScript = document.createElement('script');
    initScript.innerHTML =
      `window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag('js', new Date());
      gtag('config', '${Vue.googleAnalyticsId}', { 'send_page_view': false });`
    head.appendChild(initScript);

    Vue.googleAnalyticsInserted = true;
  },

  sendGoogleAnalytics(data) {
    gtag('config', Vue.googleAnalyticsId, data);
  },

  install(Vue, options) {
    if (!options || !options.id)
      throw new Error('Google Analytics id is required');

    Vue.prototype.insertGoogleAnalyticsSnippet = this.insertGoogleAnalyticsSnippet;
    Vue.prototype.sendGoogleAnalytics = this.sendGoogleAnalytics;
    Vue.googleAnalyticsInserted = false;
    Vue.googleAnalyticsId = options.id;
  }

}



// WEBPACK FOOTER //
// ./src/helpers/googleAnalytics.js